<template>
  <g>
    <path
      d="M24 12.07A12 12 0 1010.12 24v-8.44H7.08v-3.49h3.05V9.41c0-3.02 1.79-4.7 4.53-4.7a18.34 18.34 0 012.68.24v2.97h-1.5a1.74 1.74 0 00-1.97 1.89v2.26h3.33l-.53 3.5h-2.8V24A12.05 12.05 0 0024 12.07z"
      fill="currentColor"
    />
  </g>
</template>
